/**
 * Glass Bottom Nav (mobile)
 * -------------------------
 * Drives <glass-bottom-nav> (see snippets/glass-bottom-nav.liquid):
 *   - Hides the bar while the page is actively scrolling (past a 50px
 *     threshold from the top) and brings it back once scrolling stops for
 *     ~150ms, regardless of scroll direction.
 *   - Keeps the cart badge in sync the same way the header's <cart-count>
 *     does: this theme's cart-drawer/cart-notification-popup/cart-page
 *     components emit their own "update-nodes" event (via their built-in
 *     emit/on/off bus, not a native DOM CustomEvent) after a successful
 *     add-to-cart. We subscribe to the same sources and re-fetch /cart.js
 *     to grab the fresh item_count the instant that fires.
 *   - The cart item opens the theme's cart drawer (#CartDrawer, the same
 *     <sidebar-component> the header cart icon controls) instead of
 *     navigating, when the snippet marks it with
 *     [data-glass-nav-cart-drawer-target]; falls back to normal navigation
 *     if the drawer element isn't present.
 */
(function () {
  'use strict';

  if (window.customElements && customElements.get('glass-bottom-nav')) return;

  var HIDE_THRESHOLD = 50;
  var SCROLL_END_DELAY = 150;
  var CART_SOURCE_SELECTORS = ['cart-drawer', 'cart-notification-popup', 'cart-page'];

  class GlassBottomNav extends HTMLElement {
    connectedCallback() {
      this._hideOnScroll =
      this.dataset.hideOnScroll === 'true' ||
      this.dataset.hideOnScroll === '1';

      if (this._init) return;
      this._init = true;

      if (!this._hideOnScroll) {
        this.classList.remove('is-hidden');
      }

      this._ticking = false;
      this._scrollEndTimer = null;
      this._badge = this.querySelector('[data-glass-nav-cart-badge]');
      this._cartSources = [];

      this._onScroll = this._onScroll.bind(this);
      this._onCartUpdate = this._onCartUpdate.bind(this);
      this._onClick = this._onClick.bind(this);

      if (this._hideOnScroll) {
  window.addEventListener('scroll', this._onScroll, { passive: true });
}
      this.addEventListener('click', this._onClick);

      var self = this;
      CART_SOURCE_SELECTORS.forEach(function (selector) {
        var source = document.querySelector(selector);
        if (source && typeof source.on === 'function') {
          source.on('update-nodes', self._onCartUpdate);
          self._cartSources.push(source);
        }
      });
    }

    disconnectedCallback() {
      if (this._hideOnScroll) {
        window.removeEventListener('scroll', this._onScroll);
      }
      this.removeEventListener('click', this._onClick);
      if (this._scrollEndTimer) clearTimeout(this._scrollEndTimer);

      var self = this;
      this._cartSources.forEach(function (source) {
        if (typeof source.off === 'function') source.off('update-nodes', self._onCartUpdate);
      });
      this._cartSources = [];
    }

    _onClick(event) {
      var trigger = event.target.closest('[data-glass-nav-cart-drawer-target]');
      if (!trigger) return;

      var drawer = document.getElementById(trigger.getAttribute('data-glass-nav-cart-drawer-target'));
      if (!drawer || typeof drawer.open !== 'function') return;

      event.preventDefault();
      drawer.open(event);
    }

    _onScroll() {
      var self = this;

      if (!this._ticking) {
        this._ticking = true;
        window.requestAnimationFrame(function () {
          self._updateHiddenState();
          self._ticking = false;
        });
      }

      if (this._scrollEndTimer) clearTimeout(this._scrollEndTimer);
      this._scrollEndTimer = window.setTimeout(function () {
        self.classList.remove('is-hidden');
      }, SCROLL_END_DELAY);
    }

    _updateHiddenState() {
      var currentY = Math.max(window.scrollY || 0, 0);
      this.classList.toggle('is-hidden', currentY > HIDE_THRESHOLD);
    }

    _onCartUpdate() {
      if (!this._badge) return;

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (freshCart) { this._setBadge(freshCart.item_count); }.bind(this))
        .catch(function () {});
    }

    _setBadge(count) {
      this._badge.textContent = count > 99 ? '99+' : String(count);
      this._badge.hidden = count === 0;
    }
  }

  customElements.define('glass-bottom-nav', GlassBottomNav);
})();
